<script setup>
defineProps({
  url: {
    type: String,
    default: () => '',
  },
  image: {
    type: Object,
    default: () => {},
  },
  title: {
    type: String,
    default: () => '',
  },
  description: {
    type: String,
    default: () => '',
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div :class="`pages-cards__item pages-cards__item--${backgroundColor}`">
    <div v-if="image" class="pages-cards__item-media">
      <NuxtImg
        v-if="image?.src"
        :src="image.src"
        :alt="image.alt"
        :height="image.height"
        :width="image.width"
        class="pages-cards__item-image"
        loading="lazy"
      />
    </div>
    <div class="pages-cards__item-info">
      <div
        :class="[
          'pages-cards__item-text',
          backgroundColor === 'black' ? 'white' : '',
        ]"
      >
        <p
          v-if="title"
          class="mb-0 pages-cards__item-title h5"
          v-html="title"
        ></p>
        <div
          v-if="description"
          class="pages-cards__item-description body-2-regular"
          v-html="description"
        ></div>
      </div>
      <Button v-if="url" v-slot="slotProps" as-child rounded variant="outlined">
        <CTagDetect
          :to="url"
          :class="slotProps.class"
          class="pages-cards__item-button button-next js-button-inner-page-card"
          :aria-label="title"
        >
          <CIcon
            class="button-next__icon"
            :name="
              backgroundColor === 'black'
                ? 'direction-white'
                : 'direction-black'
            "
            width="16"
            height="16"
          />
        </CTagDetect>
      </Button>
    </div>
  </div>
</template>
<style scoped lang="scss">
.pages-cards__item {
  $parent: &;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  padding: 16px;
  @include media-breakpoint-up(sm) {
    gap: 24px;
    padding: 24px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(border-radius, 4);
    @include responsive-spacing(gap, 24);
    @include responsive-spacing(padding, 24);
  }
  &--white {
    background-color: $gray;
  }
  &--black {
    background-color: rgba($surface-container-opacity, 0.5);
  }
  &--gray {
    background-color: $white;
  }
  &-media {
    border-radius: 4px;
    aspect-ratio: 1/1;
    overflow: hidden;
    width: 64px;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
      @include responsive-spacing(width, 64);
    }
  }
  &-image {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  &-info {
    align-items: end;
    display: grid;
    gap: 16px;
    grid-template-columns: auto 48px;
    min-height: 48px;
    @include media-breakpoint-up(sm) {
      min-height: 58px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 16);
      @include responsive-spacing(min-height, 48);
      grid-template-columns: auto px-to-vw(48);
    }
  }
  &-text {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  &-title {
    margin: 0;
  }
  &-description {
    &:deep(p:last-child) {
      margin: 0;
    }
  }
}
</style>
